import { NgModule } from '@angular/core';
import { DateRangeComponent } from './date-range.component';

@NgModule({
  exports: [DateRangeComponent],
  imports: [DateRangeComponent]
})
export class DateRangeModule {}
